import i18n from "i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import { initReactI18next } from "react-i18next"

// Translations are bundled as modules (not fetched over HTTP) so the
// browser can't serve a stale cached copy when keys are added, renamed,
// or reshaped between builds. This eliminates the class of bugs where
// a `t("eventEdit.enterEventName")` call rendered its literal key just
// because the browser still held the pre-rename JSON in cache. Vite
// picks up edits via HMR, so saving a translation file refreshes
// i18next immediately.
import enTranslation from "../public/locales/en/translation.json"
import arTranslation from "../public/locales/ar/translation.json"

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslation },
      ar: { translation: arTranslation },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "ar"],
    debug: false,
    ns: ["translation"],
    defaultNS: "translation",
    detection: {
      order: ["localStorage", "queryString", "cookie"],
      caches: ["localStorage", "cookie"],
      lookupLocalStorage: "i18nextLng",
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      // No async fetch happens now, so Suspense would never need to
      // render a fallback — turning it off keeps initial mount simple.
      useSuspense: false,
    },
  })

export default i18n
